import * as _ from 'lodash';

import IAllowedUse = ZoneIQCalibration.IAllowedUse;

export class AllowedUseModel implements IAllowedUse {
    Id: number;
    ZoningCodeId: number;
    Label: string;
    Name: string;
    Description: string;
    CloneId: number;
    RevisionId: number;
    UseConditionId: number;
    LabelIfOther?: string;

    constructor(data: IAllowedUse) {
        Object.assign(
            this,
            _.pick(data, [
                'Id',
                'ZoningCodeId',
                'Label',
                'Name',
                'Description',
                'CloneId',
                'RevisionId',
                'UseConditionId',
                'LabelIfOther',
                'importValidationResult'
            ])
        );
    }

    static factory(data: IAllowedUse): AllowedUseModel {
        return new AllowedUseModel(data);
    }
}
